import * as R from 'ramda';


export default function GenerateFullReportDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  bcpDataService,
  reportsDataService
) {
  const vm = this;

  vm.submitButtonText = 'Generate Document';

  vm.saveDocument = false;
  vm.renderFullReport = true;
  vm.isFullReportIndeterminate = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleRunReport = _handleRunReport;
  vm.handleFullReport = _handleFullReport;
  vm.handleSelectReport = _handleSelectReport;
  vm.handleSectionChange = _handleSectionChange;
  vm.handleSelectSaveDocument = _handleSelectSaveDocument;

  vm.noneChecked = _noneChecked;
  vm.noneCheckedMessage = _noneCheckedMessage;

  vm.reports = _getReports();

  /** ************************************************
   * Event Handlers
   */

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.generateFullReportDialog);
  }

  function _handleRunReport() {
    console.log('_handleRunReport');
    const dfdSave = $q.defer();

    if ($scope.bcpGenerateFullReportForm.$valid) {
      const reportSections = R.join(',',
        R.pluck(
          'reportSectionId',
          R.filter(
            R.allPass([
              R.propEq('isSelected', true),
              R.propEq('isActive', true)
            ]),
            vm.reports
          )
        ));

      alerts.info('Please Wait! Queueing report. It may take little longer than normal to get the report');
      loaderService.showViewLoader = true;
      const downloadCall = bcpDataService.generateFullReport(
        {
          assessmentId: vm.assessment.assessmentId,
          name: vm.assessment.name,
          reportSection: reportSections,
          renderFullReport: vm.renderFullReport,
          saveDocument: vm.saveDocument,
        }
      );

      downloadCall.then((downloadDocumentResponse) => {
        alerts.success('The BCP assessment document was generated successfully.');
        loaderService.showViewLoader = false;
        reportsDataService.download(downloadDocumentResponse);
        $rootScope.$broadcast('refreshBCPAssessments');
      });

      _handleCloseDialog();
      dfdSave.resolve();
    } else {
      dfdSave.reject();
    }
  }

  function _handleFullReport() {
    R.forEach(
      (report) => {
        report.isSelected = vm.renderFullReport;
      },
      vm.reports
    );
  }

  function _handleSelectReport() {
    const reportsShown = R.filter(
      R.propEq('isActive', true),
      vm.reports
    );

    if (reportsShown !== null) {
      const reportsSelected = R.filter(
        R.propEq('isSelected', true),
        reportsShown
      );

      if (reportsSelected !== null) {
        vm.renderFullReport = reportsShown.length === reportsSelected.length;
      }
    }
  }

  function _handleSelectSaveDocument() {
    if (vm.saveDocument === true) {
      vm.submitButtonText = 'Generate Plan for Board Approval';
    } else {
      vm.submitButtonText = 'Generate Document';
    }
  }

  function _handleSectionChange() {
    let chkboxCtrls;
    vm.renderFullReport = chkboxCtrls
      || chkboxCtrls.length === 0;
    // _SaveDocumentSelection(vm.renderFullReport);
    // _noneChecked(form);
  }

  // Validation
  function _noneChecked() {
    const selected = R.filter(
      R.allPass([
        R.propEq('isSelected', true),
        R.propEq('isActive', true)
      ]),
      vm.reports
    );

    return R.isNil(selected) || selected.length === 0;
  }

  function _noneCheckedMessage(form) {
    let result = null;
    if (form) {
      const selected = angular.element('input:checked[name="renderReportSec"]');

      if (
        selected
        || selected.length === 0
      ) {
        const ctrl = form.renderFullReport;
        if (ctrl) {
          result = ctrl.$error;
        }
      }
    }
    return result;
  }

  /** ************************************************
   * Private Functions
   */

  function _getReports() {
    return [
      {
        title: 'Plan Overview',
        reportSectionId: 1,
        isSelected: true,
        isActive: true
      },
      {
        title: 'Governance',
        reportSectionId: 2,
        isSelected: true,
        isActive: true
      },
      {
        title: 'Business Impact Analysis',
        reportSectionId: 3,
        isSelected: true,
        isActive: true
      },
      {
        title: 'Risk Identification and Assessment',
        reportSectionId: 4,
        isSelected: true,
        isActive: true
      },
      {
        title: 'Business Continuity Strategies',
        reportSectionId: 5,
        isSelected: true,
        isActive: true
      },
      {
        title: 'Testing and Training',
        reportSectionId: 6,
        isSelected: true,
        isActive: true
      },
      {
        title: 'Pandemic Policy',
        reportSectionId: 7,
        isSelected: true,
        isActive: vm.assessment.includePandemicPolicy
      },
      {
        title: 'Emergency Plan',
        reportSectionId: 8,
        isSelected: true,
        isActive: vm.assessment.includeEmergencyPlan
      },
      {
        title: 'Key Contacts',
        reportSectionId: 9,
        isSelected: true,
        isActive: vm.assessment.includeKeyContacts
      },
      {
        title: 'Schematic / Network Diagram',
        reportSectionId: 10,
        isSelected: true,
        isActive: vm.assessment.includeSchematics
      },
    ];
  }

  // function _SaveDocumentSelection(ischecked) {
  // var saveDoc = angular.element('input[name="saveDocument"]');
  // if (ischecked) {
  //  saveDoc.removeAttr('disabled');
  // } else {
  //  saveDoc.removeAttr('checked');
  //  saveDoc.attr(
  //  'disabled',
  //  'disabled'
  //  );
  // }
  // }
}

GenerateFullReportDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'bcpDataService',
  'reportsDataService',
];
